<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>审单管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :collapse="true">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="120px"
               label-position="right"
               size="medium"
               @submit.native.prevent="handleSearch">
        <div class="re-el-form__flex">
          <el-form-item label="项目"
                        prop="projectid">
            <remote-select class="width-max"
                           clearable
                           multiple
                           id-key="number"
                           label-key="name"
                           value-key="id"
                           @change="projectIdChanged"
                           placeholder="请选择"
                           v-model="search.projectid"
                           :query-request="getProjectTableQuery"
                           :find-request="getProjectDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="批次"
                        prop="batchid">
            <remote-select class="width-max"
                           clearable
                           multiple
                           :disabled="!search.projectid || !search.projectid.length"
                           id-key="number"
                           label-key="detail"
                           value-key="id"
                           placeholder="请选择"
                           v-model="search.batchid"
                           :query-request="(_) => getBatchTable(Object.assign({projectid: search.projectid}, _))"
                           :find-request="getBatchDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="所在区域"
                        prop="taskmarketareaid">
            <el-select v-model="search.taskmarketareaid"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.taskmarketareaid"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="初审管理员"
                        prop="first_reviewerid">
            <remote-select class="width-max"
                           clearable
                           id-key="id"
                           keyword-key="name"
                           label-key="name"
                           value-key="id"
                           placeholder="请选择实习生"
                           v-model="search.first_reviewerid"
                           :query-request="getInternUserTable"
                           :find-request="getInternUserDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="复核状态"
                        prop="cstaskstatus">
            <el-select v-model="search.cstaskstatus"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in reviewStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分配状态"
                        prop="allocation_status">
            <el-select v-model="search.allocation_status"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option label="未分配"
                         :value="0"></el-option>
              <el-option label="已分配"
                         :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="复核人"
                        prop="recheckerid">
            <remote-select class="width-max"
                           clearable
                           id-key="id"
                           keyword-key="name"
                           label-key="name"
                           value-key="id"
                           placeholder="请选择"
                           v-model="search.recheckerid"
                           :query-request="getPlatformUsersIndex"
                           :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="审核通过时间"
                        prop="userfinishtime"
                        class="re-el-form__interval">
            <el-date-picker v-model="search.userfinishtime"
                            style="width: 100%;"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="请选择"
                            end-placeholder="请选择"
                            align="right"
                            clearable
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="工单ID高级检索"
                        prop="orderid"
                        label-width="120px">
            <el-input v-model="search.orderid"
                      placeholder="多个用逗号分隔"
                      clearable></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit"
                     size="mini">搜索
          </el-button>
          <el-button type="warning"
                     size="mini"
                     @click="showExportSearchDialog">按搜索结果导出
          </el-button>
          <el-button type="primary"
                     size="mini"
                     @click="showAssignReviewBySearchDialog">按搜索结果分配复核
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="sj-icon-export"
                   @click="showExportDialog"></el-button>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button type="primary"
                   size="mini"
                   @click="showAssignReviewBySelectionDialog">按勾选分配复核人
        </el-button>
        <el-tooltip content="请确保搜索条件中的 项目 的已选条目个数为 1 个"
                    v-if="search.projectid.length > 0 && search.userid > 0"
                    :disabled="getFirstSearchProjectId() > 0"
                    placement="top"
                    effect="dark">
          <el-button style="margin-left: 10px;"
                     :disabled="getFirstSearchProjectId() < 1"
                     type="primary"
                     size="mini"
                     @click="showAllowanceDialog">执行补贴
          </el-button>
        </el-tooltip>

      </div>
      <el-table :data="table"
                class="order-review-table"
                stripe
                highlight-current-row
                border
                style="width: 100%"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                @sort-change="sortChange"
      >
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column prop="orderid"
                         width="116px"
                         label="工单ID"
        >
          <template slot-scope="scope">
            ORD{{ scope.row.orderid }}
          </template>
        </el-table-column>
        <el-table-column prop="customer"
                         label="所属客户"
                         min-width="120"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.customerid">{{ scope.row.customername }}/{{ scope.row.customernumber }}</span>
            <span v-if="!scope.row.customerid">平台</span>
          </template>
        </el-table-column>
        <el-table-column prop="batchname"
                         label="所属批次"
                         min-width="120"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="cell-wrap"
                  :title="formatBatchCell(scope.row)">{{ formatBatchCell(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="title"
                         label="任务名称"
                         min-width="160"
        >
          <template slot-scope="scope">
            <router-link :to="'/order/detail/'+scope.row.orderid"
                         class="cell-link"
                         style="text-decoration:none">
              <span class="cell-wrap"
                    :title="scope.row.title"
                    style="color:rgb(88,157,248);">{{ scope.row.title }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="userid"
                         label="零工ID"
                         width="120px"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="scope.row.userid && scope.row.userid !== 0">
              <router-link :to="'/users/table?keyword='+scope.row.userid"
                           style="text-decoration:none">
                <span style="color:rgb(88,157,248);">{{ scope.row.userid }}</span>
                <span v-if="scope.row.user_name"> | {{ scope.row.user_name }}</span>
              </router-link>
            </template>
            <span v-else>{{ scope.row.user_name || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="salary"
                         label="赏金"
                         width="65px"
        >
          <template slot-scope="scope">
            {{ salaryValue(scope.row.salary) }}
          </template>
        </el-table-column>
        <el-table-column label="任务时间"
                         width="100px"
        >
          <template slot-scope="scope">
            <span class="cell-wrap"
                  :title="scope.row.starttime + ' - ' + scope.row.endtime">{{ scope.row.starttime }} - {{ scope.row.endtime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="城市"
                         min-width="100"
        >
          <template slot-scope="scope">
            <span class="cell-wrap"
                  :title="scope.row.provincename + scope.row.cityname + scope.row.areaname">{{ scope.row.provincename }}{{ scope.row.cityname }}{{ scope.row.areaname }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="marketname"
                         label="门店名称"
        >
          <template slot-scope="scope">
            <router-link :to="'/market/table?id='+scope.row.marketid" target="_blank">
              {{ scope.row.marketname | sjfmarketname(scope.row.type) }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="任务状态"
                         width="92px"
        >
          <template slot-scope="scope">
          <span v-for="item in options.status"
                v-if="scope.row.status === item.value">{{ item.label }}</span>
          </template>
        </el-table-column>
        <el-table-column label="分配状态"
                         width="94px"
        >
          <template slot-scope="scope">
            {{ getAllocationStatusLabel(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="cstaskstatus"
                         label="复核状态"
                         width="94px"
        >
          <template slot-scope="scope">
            {{ getReviewStatusLabel(scope.row.cstaskstatus) }}
          </template>
        </el-table-column>
        <el-table-column prop="reviewer"
                         label="复核人"
                         min-width="120"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="cell-wrap"
                  :title="formatReviewerCell(scope.row)">{{ formatReviewerCell(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="adminname"
                         label="任务发布人"
                         width="94px"
        ></el-table-column>
        <el-table-column label="更新时间"
                         sortable="custom"
                         width="100px"
                         prop="lastupdatetime"
        >
          <template slot-scope="scope">
            <span class="cell-wrap"
                  :title="scope.row.lastupdatetime">{{ scope.row.lastupdatetime }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="120px"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.type === 127">
              <router-link :to="`/order/md/table/${scope.row.taskid}`">
                <el-button type="success"
                           size="mini">查看包含工单
                </el-button>
              </router-link>
            </template>
            <template v-else>
              <router-link :to="'/order/review/'+scope.row.orderid" target="_blank">
                <el-button type="success"
                           size="mini">查看
                </el-button>
              </router-link>
            </template>
          </template>
        </el-table-column>

      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <el-dialog
        title="导出数据确认"
        :visible.sync="dialogVisible"
        width="45%"
    >
      <div style="font-size: large">共导出{{ multipleSelection.length }}条数据</div>
      <el-checkbox class="margin t20"
                   v-model="exportAsync">后台异步导出（建议1w条数据以上时勾选，勾选后请于批量任务列表确认导出数据）
      </el-checkbox>
      <el-checkbox class="margin t20"
                   style="margin-left: 0"
                   v-model="convert_midan_task">米单类型任务转为组内任务导出
      </el-checkbox>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="onExportPage(0, 1)"
                   :disabled="multipleSelection.length === 0"
                   size="mini">按Dashboard格式导出</el-button>
        <el-button type="primary"
                   @click="onExportPage(1, 0)"
                   :disabled="multipleSelection.length === 0"
                   size="mini">仅导出任务基本数据</el-button>
        <el-button type="primary"
                   @click="onExportPage(0, 0)"
                   :disabled="multipleSelection.length === 0"
                   size="mini">导出任务全部数据</el-button>
        <el-button @click="dialogVisible = false"
                   size="mini">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导出前置抓拍准确率数据确认"
               :visible.sync="dialogSneakSimilarVisible"
               width="30%">
      <div style="font-size: large">共导出{{ exportCount }}条数据</div>
      <el-checkbox class="margin t20"
                   style="margin-left: 0"
                   v-model="convert_midan_task">米单类型任务转为组内任务导出
      </el-checkbox>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   size="mini"
                   :disabled="exportCount === 0"
                   @click="onExportOrderSneakSimilarity()">导出数据</el-button>
        <el-button size="mini"
                   @click="() => { dialogSneakSimilarVisible = false; convert_midan_task = false;}">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="工单数据交换"
               :visible.sync="dialogExchangeOrderVisible"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               width="40%">
      <el-form :model="exchangeOrderForm"
               ref="exchangeOrderForm"
               label-width="96px"
               size="medium">
        <el-form-item label="工单1 ID"
                      prop="orderid1">
        <el-input v-model="exchangeOrderForm.orderid1"
                  placeholder="请输入工单ID,必须为纯数字,例如 66534128">
        </el-input>
        </el-form-item>
        <el-form-item label="工单2 ID"
                      prop="orderid2">
          <el-input v-model="exchangeOrderForm.orderid2"
                    placeholder="请输入工单ID,必须为纯数字,例如 66534128">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="warning"
                   size="mini"
                   @click="doExchangeOrder()">交换数据</el-button>
        <el-button size="mini"
                   @click="closeExchangeOrderDialog()">取消交换</el-button>
      </span>
    </el-dialog>

    <order-allowance-dialog :visible="dialogAllowanceVisible" :info="allowanceInfo" @closeDialog="dialogAllowanceVisible=false"></order-allowance-dialog>
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'
import OrderOnBatchSucceedButton from '../components/buttons/OrderOnBatchSucceedButton'
import OrderOnBatchWithdrawButton from '../components/buttons/OrderOnBatchWithdrawButton'
import OrderOnBatchCheckButton from '../components/buttons/OrderOnBatchCheckButton'
import TaskDescButton from '@/views/task/components/buttons/TaskDescButton'
import OrderAllowanceDialog from '@/views/order/components/OrderAllowanceDialog'

// 审核通过状态值（工单复核页强制只查此状态）
const AUDIT_PASSED_STATUS = 5

// 复核状态枚举：空/0 待复核，1 复核正常，2 复核异常，3 分配中
const REVIEW_STATUS_MAP = {
  0: '待复核',
  1: '复核正常',
  2: '复核异常',
  3: '分配中'
}

export default {
  mixins: [table],
  components: {
    OrderOnBatchSucceedButton,
    OrderOnBatchWithdrawButton,
    OrderOnBatchCheckButton,
    TaskDescButton,
    OrderAllowanceDialog
  },
  data () {
    return {
      table: [],
      multipleSelection: [],
      dialogVisible: false,
      dialogAllowanceVisible: false,
      dialogSneakSimilarVisible: false,
      dialogExchangeOrderVisible: false,
      exportCount: 0,
      search: {
        platformtype: null,
        onlineRange: [],
        offlineRange: [],
        reformat: 1,
        start_begin: null,
        start_end: null,
        endtime_begin: null,
        endtime_end: null,
        customerid: null,
        projectid: [],
        type: null,
        batchid: [],
        status: [AUDIT_PASSED_STATUS], // 工单复核页强制只查「审核通过」
        templateid: null,
        addto_taskgroup_target_num: null,
        userid: null,
        taskmarketareaid: null,
        marketname: null,
        locked: null,
        text: null,
        review_begin: null,
        review_end: null,
        sort_by_review: null,
        sort_by_lastupdatetime: null,
        sort_by_endtime: null,
        userfinishtime: [],
        audit_at_begin: null,
        audit_at_end: null,
        first_reviewerid: null,
        recheckerid: null,
        cstaskstatus: null,
        allocation_status: null,
        orderid: null,
        not_type: [21],
      },
      searchFieldType: {
        type: Number,
        status: Array,
        locked: Number,
        review_begin: Number,
        review_end: Number,
        taskmarketareaid: Number,
        addto_taskgroup_target_num: Number,
        recheckerid: Number,
        cstaskstatus: Number,
        allocation_status: Number,
      },
      exportAsync: false,
      convert_midan_task: false,
      dashboardFormat: false,
      exchangeOrderForm: {
        orderid1: null,
        orderid2: null,
      },
      allowanceInfo: {
        order_ids: [],
        provinceid: 0,
        projectid: 0,
        userid: 0,
        remain_amount: 0
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.order.options,
    }),
    reviewStatusOptions () {
      return [
        { label: '待复核', value: 0 },
        { label: '复核正常', value: 1 },
        { label: '复核异常', value: 2 },
      ]
    },
  },
  methods: {
    ...request.map([
      'getProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail',
      'getQueryReviewTaskList',
    ]),
    ...Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']),
    // 项目下拉：合并分页等默认参数，避免空参数导致 query_project 接口报错
    getProjectTableQuery (params) {
      return request('getProjectTable', Object.assign(
        { per_page: 20, current_page: 1 },
        params || {}
      ))
    },
    /**
     * 获取实习生列表（统一走 audit-intern.api.js 中的 queryInternTableApi）
     */
    getInternUserTable (params) {
      return request('queryInternTableApi', params)
    },
    /**
     * 获取实习生详情（使用 audit-intern.api.js 中的 getInternBaseInfoApi）
     */
    getInternUserDetail (params) {
      return request('getInternBaseInfoApi', params)
    },
    projectIdChanged () {
      if (this.search.batchid && this.search.batchid.length > 0) {
        this.search.batchid = []
      }
    },
    handleSearch () {
      if (this.search.userfinishtime && this.search.userfinishtime.length === 2) {
        this.search.audit_at_begin = this.search.userfinishtime[0]
        this.search.audit_at_end = this.search.userfinishtime[1]
      } else {
        this.search.audit_at_begin = null
        this.search.audit_at_end = null
      }
      this.onSearch()
    },
    getReviewStatusLabel (value) {
      if (value === 1 || value === 2) {
        return REVIEW_STATUS_MAP[value]
      }
      return '待复核'
    },
    getAllocationStatusLabel (row) {
      if (row.reviewer_id != null && row.reviewer_id !== '' && row.reviewer_name != null && row.reviewer_name !== '') {
        return '已分配'
      }
      return '未分配'
    },
    getTableData (params) {
      const mergedParams = { ...params }
      const requestParams = {
        page: mergedParams.current_page,
        per_page: mergedParams.per_page,
        projectid: mergedParams.projectid,
        batchid: mergedParams.batchid,
        taskmarketareaid: mergedParams.taskmarketareaid,
        first_reviewerid: mergedParams.first_reviewerid,
        cstaskstatus: mergedParams.cstaskstatus,
        recheckerid: mergedParams.recheckerid,
        audit_at_begin: mergedParams.audit_at_begin,
        audit_at_end: mergedParams.audit_at_end,
        taskid: mergedParams.taskid,
        orderid: mergedParams.orderid,
        audit_status: mergedParams.audit_status,
        review_status: mergedParams.review_status,
        customer_id: mergedParams.customer_id,
      }
      // 分配状态：0 未分配 1 已分配（无默认值，未选时不传）
      if (mergedParams.allocation_status === 0 || mergedParams.allocation_status === 1) {
        requestParams.allocation_status = mergedParams.allocation_status
      }
      return request.page('getQueryReviewTaskList', requestParams).then(res => {
        const body = res.data || {}
        // 接口返回 data 为分页对象时：data.data 为列表
        const paginator = body.data || {}
        const list = (paginator.data || body.data || []).map(item => this.mapAuditedResultToRow(item))
        return {
          data: {
            data: list,
            total: paginator.total != null ? paginator.total : (body.total || 0),
            current_page: paginator.current_page != null ? paginator.current_page : (body.current_page || 1),
            per_page: paginator.per_page != null ? paginator.per_page : (body.per_page || 20),
          },
        }
      })
    },
    // 将 audited_order_result + audit_task 转为表格行（主表一条，从表取一条）
    mapAuditedResultToRow (item) {
      const task = item.audit_task || {}
      return {
        id: item.id,
        orderid: item.orderid,
        title: task.title || item.task_market_name || '',
        type: task.type,
        userid: task.userid != null ? task.userid : item.userid,
        user_name: task.user_name || item.user_name || '',
        salary: task.salary,
        starttime: task.starttime || item.task_starttime || '',
        endtime: task.endtime || item.task_endtime || '',
        provincename: task.provincename || '',
        cityname: task.cityname || '',
        areaname: task.areaname || '',
        marketname: task.marketname || item.task_market_name || '',
        marketid: task.marketid || item.task_market_id,
        status: task.status,
        isInAudit: Number(item.audit_status) === 1,
        cstaskstatus: item.review_status,
        reviewer_id: item.reviewer_id,
        reviewer_name: item.reviewer_name || '',
        adminname: task.adminname || item.task_creator_name || '',
        customerid: task.customerid != null ? task.customerid : item.customer_id,
        customername: task.customername || '',
        customernumber: task.customernumber || '',
        review: task.review != null ? task.review : item.audit_times,
        lastupdatetime: task.lastupdatetime || '',
        publishtime: task.publishtime || '',
        taskid: item.taskid,
        batchid: task.batchid != null ? task.batchid : item.batchid,
        batchname: task.batchname || task.batch_name || item.batch_name || item.batchname || '',
        batch_detail: task.batch_detail || item.batch_detail || '',
      }
    },
    formatBatchCell (row) {
      const name = (row.batchname || row.batch_detail || '').trim()
      if (name) return name
      if (row.batchid != null && row.batchid !== '') return String(row.batchid)
      return '-'
    },
    formatReviewerCell (row) {
      const name = (row.reviewer_name || '').trim()
      const id = row.reviewer_id != null && row.reviewer_id !== '' ? String(row.reviewer_id).trim() : ''
      if (name && id) return `${name}/${id}`
      if (name) return name
      if (id) return id
      return ''
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    batchSucceed () {
      this.$refs.multipleTable.clearSelection()
      this.onSearch()
    },
    sortChange (column, prop, order) {
      let sortBy = 'asc'
      if (column.order === 'descending') {
        sortBy = 'desc'
      }
      if (column.prop === 'lastupdatetime') {
        this.search.sort_by_lastupdatetime = sortBy
      } else if (column.prop === 'endtime') {
        this.search.sort_by_endtime = sortBy
      }
      this.onSearch()
    },
    onExportPage (onlyBasic, dashboardFormat) {
      this.dialogVisible = false
      let multipleIds = {
        orderid: this.multipleSelection.map(item => item.orderid),
        only_basic: onlyBasic,
        export_async: this.exportAsync,
        dashboard_format: dashboardFormat,
        convert_midan_task: this.convert_midan_task,
      }

      if (multipleIds.orderid.length <= 0) {
        this.$message.error('请至少选择批量导出一个')
        return false
      }

      if (this.exportAsync) {
        return this.onExportAsync(multipleIds)
      }

      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, {
        fileHeader: this.exportHeader,
        total: multipleIds.orderid.length,
        request: (params) => request('exportOrder', params),
        requestParams: multipleIds,
        fileType: 'csv',
        type: 'array',
        getResponseData (data) {
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onExportSearch () {
      if (!this.pagination.total) {
        this.$message.warning('当前没有可导出的数据')
        return
      }
      const searchParams = { ...this.search }
      if (this.search.userfinishtime && this.search.userfinishtime.length === 2) {
        searchParams.audit_at_begin = this.search.userfinishtime[0]
        searchParams.audit_at_end = this.search.userfinishtime[1]
      }
      this.$export(`${this.$route.meta.title}-搜索结果-${this.pagination.current_page}P`, {
        fileHeader: this.getSearchExportHeaders(),
        total: this.pagination.total,
        request: params => this.getTableData(params),
        requestParams: searchParams,
        fileType: 'csv',
      })
    },
    onExportAsync (detail) {
      return request.common('exportOrder', { ...detail, status: [AUDIT_PASSED_STATUS] }).then(() => {
        return this.$message.success('创建成功，请在任务管理中心查看！')
      })
    },
    showExchangeOrderDialog () {
      this.$set(this, 'exchangeOrderForm', {
        orderid1: null,
        orderid2: null,
      })
      this.dialogExchangeOrderVisible = true
    },
    closeExchangeOrderDialog () {
      this.dialogExchangeOrderVisible = false
    },
    showExportSneakSimilarityDialog () {
      this.exportCount = this.pagination.total
      this.dialogSneakSimilarVisible = true
    },
    countDown (date) {
      let futureTs = (Date.parse(date) + '').substr(0, 10)
      let currentTs = ((new Date()).getTime() + '').substr(0, 10)
      let interval = futureTs - currentTs

      if (interval < 0) {
        return ''
      }

      return filter.formatTimerHumanize(interval)
    },
    showExportDialog () {
      this.dialogVisible = true
      this.exportAsync = false
      this.convert_midan_task = false
    },
    showExportSearchDialog () {
      this.onExportSearch()
    },
    getSearchExportHeaders () {
      return [
        {
          key: 'orderid',
          text: '工单ID',
          formatter: row => `ORD${row.orderid || ''}`,
        },
        {
          key: 'customer',
          text: '所属客户',
          formatter: row => {
            if (row.customerid) {
              return `${row.customername || ''}/${row.customernumber || ''}`
            }
            return '平台'
          },
        },
        {
          key: 'batchname',
          text: '所属批次',
          formatter: row => this.formatBatchCell(row),
        },
        {
          key: 'title',
          text: '任务名称',
          formatter: row => row.title || '',
        },
        {
          key: 'userid',
          text: '零工ID',
          formatter: row => {
            if (row.userid && row.userid !== 0) {
              return row.user_name ? `${row.userid} | ${row.user_name}` : `${row.userid}`
            }
            return row.user_name || '-'
          },
        },
        {
          key: 'salary',
          text: '赏金',
          formatter: row => this.salaryValue(row.salary),
        },
        {
          key: 'task_time',
          text: '任务时间',
          formatter: row => `${row.starttime || ''} - ${row.endtime || ''}`,
        },
        {
          key: 'city',
          text: '城市',
          formatter: row => `${row.provincename || ''}${row.cityname || ''}${row.areaname || ''}`,
        },
        {
          key: 'marketname',
          text: '门店名称',
          formatter: row => filter.sjfmarketname(row.marketname, row.type),
        },
        {
          key: 'status',
          text: '任务状态',
          formatter: row => this.getTaskStatusLabel(row.status),
        },
        {
          key: 'allocation_status',
          text: '分配状态',
          formatter: row => this.getAllocationStatusLabel(row),
        },
        {
          key: 'cstaskstatus',
          text: '复核状态',
          formatter: row => this.getReviewStatusLabel(row.cstaskstatus),
        },
        {
          key: 'reviewer',
          text: '复核人',
          formatter: row => this.formatReviewerCell(row),
        },
        {
          key: 'adminname',
          text: '任务发布人',
          formatter: row => row.adminname || '',
        },
        {
          key: 'lastupdatetime',
          text: '更新时间',
          formatter: row => row.lastupdatetime || '',
        },
      ]
    },
    getTaskStatusLabel (value) {
      const statusItem = (this.options.status || []).find(item => item.value === value)
      return statusItem ? statusItem.label : ''
    },
    showAssignReviewBySearchDialog () {
      const searchCopy = { ...this.search }
      if (this.search.userfinishtime && this.search.userfinishtime.length === 2) {
        searchCopy.audit_at_begin = this.search.userfinishtime[0]
        searchCopy.audit_at_end = this.search.userfinishtime[1]
      }
      searchCopy.status = [AUDIT_PASSED_STATUS]
      sessionStorage.setItem('assign_review_params', JSON.stringify({
        mode: 'search',
        search: searchCopy,
      }))
      const query = { mode: 'search' }
      const searchParams = ['projectid', 'batchid', 'taskmarketareaid', 'first_reviewerid', 'cstaskstatus', 'allocation_status', 'recheckerid', 'audit_at_begin', 'audit_at_end', 'orderid']
      searchParams.forEach(key => {
        const v = searchCopy[key]
        if (v !== undefined && v !== null && v !== '') {
          query[key] = Array.isArray(v) ? v.join(',') : v
        }
      })
      this.$router.push({ path: '/order/assign-review', query })
    },
    showAssignReviewBySelectionDialog () {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning('请先勾选要分配复核人的工单')
        return
      }
      const orderIds = this.multipleSelection.map(item => item.orderid)
      sessionStorage.setItem('assign_review_params', JSON.stringify({
        mode: 'selection',
        orderIds,
      }))
      this.$router.push({
        path: '/order/assign-review',
        query: { mode: 'selection', orderid: orderIds.join(',') },
      })
    },
    async showAllowanceDialog () {
      let multipleIds = {
        orderid: this.multipleSelection.map(item => item.orderid)
      }
      if (multipleIds.orderid.length <= 0) {
        this.$message.error('请至少选择一个工单')
        return false
      }
      if (!this.multipleSelection.every(v => { return v.provinceid === this.multipleSelection[0].provinceid })) {
        this.$message.error('工单省份不一致')
        return false
      }

      let params = {
        order_ids: multipleIds.orderid,
        provinceid: this.multipleSelection[0].provinceid,
        province_name: this.multipleSelection[0].provincename,
        projectid: this.getFirstSearchProjectId(),
        userid: this.search.userid,
      }
      this.allowanceInfo = params
      await request.common('getExecutiveAllowance', params).then((data) => {
        this.allowanceInfo.remain_amount = data.data ? data.data : 0
      })

      this.dialogAllowanceVisible = true
    },
    salaryValue (value) {
      return filter.hasPermission(250) ? value : '*'
    },
    getFirstSearchProjectId () {
      if (this.search.projectid.length !== 1) {
        return '-1'
      }
      return _.first(this.search.projectid)
    },
    getFirstSearchBatchId () {
      if (this.search.projectid.length !== 1 || this.search.batchid.length !== 1) {
        return '-1'
      }
      return _.first(this.search.batchid)
    },
    onExportOrderSneakSimilarity () {
      const params = {
        ...this.search,
        status: [AUDIT_PASSED_STATUS],
        convert_midan_task: this.convert_midan_task,
      }
      request.common('exportOrderSneakSimilarity', params).then((data) => {
        this.$confirm('抓拍相似度导出任务创建成功，请是否前往批量任务列表中查看?', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/task/batch/table'})
        })
      })
    },
    doExchangeOrder () {
      const params = _.cloneDeep(this.exchangeOrderForm)
      this.$confirm(`确定要交换工单1 (${params.orderid1}) 与工单2 (${params.orderid2}) 的取证数据吗？`, '操作提示', {type: 'info'}).then(() => {
        request.common('allowExchangeOrderApi', params).then(({data}) => {
          if (data.canExchange === false) {
            if (data.canForceExchange === true) {
              this.$confirm(`${data.msg}, <strong style="color: red;">确定要继续强制交换工单数据吗？</strong>`, '强制交换数据提示', {type: 'warning', dangerouslyUseHTMLString: true}).then(() => {
                this.callExchangeOrderApi(params)
              }).catch(() => {})
            } else {
              this.$alert(`${data.msg}`, '禁止交换工单', {type: 'error'})
            }
          } else if (data.canExchange === true) {
            this.callExchangeOrderApi(params)
          }
        }).catch(() => {})
      })
    },
    callExchangeOrderApi (params) {
      request.common('exchangeOrderApi', params).then(({data}) => {
        this.$message.success('数据交换成功')
        this.closeExchangeOrderDialog()
      })
    },
  },
}

</script>


<style lang="scss" scoped>
.order-review-table {
  .el-table__body td .cell,
  .el-table__header th .cell {
    padding: 10px 12px;
    line-height: 1.5;
  }
  .el-table__header th .cell {
    font-weight: 500;
  }
  .cell-wrap {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
    word-break: break-all;
    line-height: 1.5;
  }
  .cell-link .cell-wrap {
    display: -webkit-box;
  }
}

.el-dialog .el-checkbox {
  white-space: normal;
}
.el-dialog .el-checkbox /deep/ .el-checkbox__label {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/views/order/pages/AssignedReviewTable.vue